import React from "react";
import { formatCompanyIdentity } from "./companyIdentityFormat";
import useCompanyIdentityChain from "./CompanyIdentityChain";

/**
 * 🎯 STANDARD COMPANY IDENTITY BLOCK
 * "Who this screen is working with" - same name/address/reg no shown on the
 * Company Dashboard. If the active company is a child in the corporate
 * structure, each parent above it is shown first (root down to active),
 * each joined to the next by an arrow, so a sibling/subsidiary is always
 * seen in the context of its parent chain.
 */
export default function CompanyIdentityHeader({ companyId, siteKey, className = "mb-3" }) {
  const { chain } = useCompanyIdentityChain(companyId, siteKey);
  if (chain.length === 0) return null;

  return (
    <div className={className}>
      {chain.map((node, i) => {
        const { name, addressLine, regNo } = formatCompanyIdentity(node.entity, node.address);
        const isActive = i === chain.length - 1;
        return (
          <div key={i}>
            <div className={isActive ? "fw-bold" : "fw-bold extra-small text-muted"}>{name}</div>
            <div className={isActive ? "extra-small text-muted" : "extra-small text-muted"}>
              <i className="bi bi-geo-alt me-1"></i>
              {addressLine}
              {regNo && <span className="ms-2">&middot; Reg No. {regNo}</span>}
            </div>
            {!isActive && <div className="extra-small text-muted my-1">--&gt;</div>}
          </div>
        );
      })}
    </div>
  );
}
